import { useQuery, UseQueryOptions } from 'react-query';
import cbsSubscriptionsService from '~/src/services/api/cbsSubscriptionsService';
import { composeQueryOpts } from '../../entities/utils';
import { APIError } from '~/src/utils/error';
import { useCurrentOrgFprint } from '~/src/entities/user';

export interface CbsSubscriptionDetails {
  has_pending_billing_cycle_change?: boolean;
  has_pending_license_quantity_change?: boolean;
  has_reseller?: boolean;
}

export const useCbsSubscriptionDetails = (
  options: UseQueryOptions<CbsSubscriptionDetails, APIError> = {},
) => {
  const orgFprint = useCurrentOrgFprint();
  const enabled = Boolean(orgFprint);

  return useQuery<CbsSubscriptionDetails, APIError>(
    composeQueryOpts(options, {
      queryKey: enabled
        ? ['cbsSubscriptionDetails', orgFprint]
        : ['cbsSubscriptionDetails'],
      queryFn: () =>
        orgFprint
          ? cbsSubscriptionsService.getSubscriptionDetailsFromCbs(orgFprint)
          : Promise.reject(new Error('Organization fingerprint missing')),
      enabled,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    }),
  );
};
